function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-839.000000, -366.000000)",
  fill: "#2D3846",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(261.000000, 102.000000)"
}, React.createElement("path", {
  d: "M591.414214,264 L592.828427,265.414214 L586.828,271.414 L592.828427,277.414214 L591.414214,278.828427 L585.414,272.828 L579.414214,278.828427 L578,277.414214 L584,271.414 L578,265.414214 L579.414214,264 L585.414,270 L591.414214,264 Z"
}))));

const SvgCloseIconSmall = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "15px",
  height: "15px",
  viewBox: "0 0 15 15",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCloseIconSmall, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-icon-small.397a3b88.svg";
export { ForwardRef as ReactComponent };